window.initApplicationQuestionForm = function() {
  $('.js-question-type').on('change', function(){
    $('[data-question-type]').addClass('is-hidden');
    $(`[data-question-type="${$(this).val()}"]`).removeClass('is-hidden');
  })
  initFormSort();

  $(document).on('change', '.js-correct', function(){
    if($(this).is(':checked')){
      $('.js-correct').not(this).prop('checked', false);
    } else {
      $(this).prop('checked', true);
    }
  })
}